import React from 'react'; 
import { ReactComponent as CycleTerminate } from '../assets/SVG/NoAccess.svg';
import Grid2 from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';

interface NoAccessPageProps {
  message?: string;
}
const NoAccessPage: React.FC<NoAccessPageProps> = ({ message }) => {
  const { t: tGeneral } = useTranslation('general');
  const  DeniedPermissionMessage = message ?? tGeneral('accessDeniedPage');
  return (
    <Grid2 
      container 
      sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
    >
      <Grid2>
        <CycleTerminate
          style={{ width: '600px', height: '400px', marginTop: '64px' }}
          role="img"
          aria-label={DeniedPermissionMessage}
        />
        <p style={{ textAlign: 'center', fontWeight: 600 }}>
          {DeniedPermissionMessage}
        </p>
      </Grid2>
    </Grid2>
  );
};

export default NoAccessPage; 
